"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportNotificationDetailCtrl = exports.MessageReasonTranslations = void 0;
var core_shared_1 = require("@ikegps/core-shared");
var core_shared_2 = require("@ikegps/core-shared");
var i18n_1 = require("../../../i18n");
var services_1 = require("../../../services");
exports.MessageReasonTranslations = {
    agl: i18n_1.T.NOTIFICATION_REASON_AGL,
    nolocation: i18n_1.T.NOTIFICATION_REASON_NO_LOCATION,
    noguywire: i18n_1.T.NOTIFICATION_REASON_NO_GUY_WIRE,
    clientitem: i18n_1.T.NOTIFICATION_REASON_CLIENT_ITEM,
    other: i18n_1.T.NOTIFICATION_REASON_OTHER,
    reason_only: i18n_1.T.NOTIFICATION_REASON_ONLY,
    missing: i18n_1.T.NOTIFICATION_REASON_MISSING,
    ipf_anchor_assembly_type_not_found: i18n_1.T.REASON_IPF_ANCHOR_ASSEMBLY_TYPE_NOT_FOUND,
    ipf_anchor_lead_length_missing: i18n_1.T.REASON_IPF_ANCHOR_LEAD_LENGTH_MISSING,
    ipf_anchor_too_many_guys: i18n_1.T.REASON_IPF_ANCHOR_TOO_MANY_GUYS,
    ipf_conductor_type_not_found: i18n_1.T.REASON_IPF_CONDUCTOR_TYPE_NOT_FOUND,
    ipf_cycle_detected: i18n_1.T.REASON_IPF_CYCLE_DETECTED,
    ipf_isolated_poles_detected: i18n_1.T.REASON_IPF_ISOLATED_POLES_DETECTED,
    ipf_equipment_attachment_height_missing: i18n_1.T.REASON_IPF_EQUIPMENT_ATTACHMENT_HEIGHT_MISSING,
    ipf_equipment_orientation_missing: i18n_1.T.REASON_IPF_EQUIPMENT_ORIENTATION_MISSING,
    ipf_equipment_type_not_found: i18n_1.T.REASON_IPF_EQUIPMENT_TYPE_NOT_FOUND,
    ipf_framing_type_not_found: i18n_1.T.REASON_IPF_FRAMING_TYPE_NOT_FOUND,
    ipf_guy_attachment_height_missing: i18n_1.T.REASON_IPF_GUY_ATTACHMENT_HEIGHT_MISSING,
    ipf_guy_type_not_found: i18n_1.T.REASON_IPF_GUY_TYPE_NOT_FOUND,
    ipf_guy_insulator_type_not_found: i18n_1.T.REASON_IPF_GUY_INSULATOR_TYPE_NOT_FOUND,
    ipf_joint_use_cable_type_not_found: i18n_1.T.REASON_IPF_JOINT_USE_CABLE_TYPE_NOT_FOUND,
    ipf_multiple_spans_linked: i18n_1.T.REASON_IPF_MULTIPLE_SPANS_LINKED,
    ipf_collection_link_one_way: i18n_1.T.REASON_IPF_COLLECTION_LINK_ONE_WAY,
    ipf_multiple_spans_same_type: i18n_1.T.REASON_IPF_MULTIPLE_SPANS_SAME_TYPE,
    ipf_power_circuit_type_not_found: i18n_1.T.REASON_IPF_POWER_CIRCUIT_TYPE_NOT_FOUND,
    ipf_service_cannot_be_collection_linked: i18n_1.T.REASON_IPF_SERVICE_CANNOT_BE_COLLECTION_LINKED,
    ipf_service_length_missing: i18n_1.T.REASON_IPF_SERVICE_LENGTH_MISSING,
    ipf_service_endpoint_missing: i18n_1.T.REASON_IPF_SERVICE_ENDPOINT_MISSING,
    ipf_target_collection_not_found: i18n_1.T.REASON_IPF_TARGET_COLLECTION_NOT_FOUND,
    ipf_service_multiple_power_circuits: i18n_1.T.REASON_IPF_SERVICE_MULTIPLE_POWER_CIRCUITS,
    ipf_service_multiple_telephone_cables: i18n_1.T.REASON_IPF_SERVICE_MULTIPLE_TELEPHONE_CABLES,
    ipf_service_multiple_catv_cables: i18n_1.T.REASON_IPF_SERVICE_MULTIPLE_CATV_CABLES,
    ipf_required_field: i18n_1.T.REASON_IPF_REQUIRED_FIELD,
    ipf_power_circuit_needs_group: i18n_1.T.REASON_IPF_POWER_CIRCUIT_NEEDS_GROUP,
    ipf_power_circuit_primary_phase_height_missing: i18n_1.T.REASON_IPF_POWER_CIRCUIT_PRIMARY_PHASE_HEIGHT_MISSING,
    ipf_power_circuit_secondary_phase_height_missing: i18n_1.T.REASON_IPF_POWER_CIRCUIT_SECONDARY_PHASE_HEIGHT_MISSING,
    ipf_count_on_span_mismatch: i18n_1.T.REASON_IPF_COUNT_ON_SPAN_MISMATCH,
    ipf_span_same_type_linked: i18n_1.T.REASON_IPF_SPAN_SAME_TYPE_LINKED,
    ipf_location_fallback_to_photo: i18n_1.T.REASON_IPF_LOCATION_FALLBACK_TO_PHOTO,
    dds_required_field: i18n_1.T.REASON_DDS_REQUIRED_FIELD,
    dds_recommended_field: i18n_1.T.REASON_DDS_RECOMMENDED_FIELD,
    dds_location_fallback_to_photo: i18n_1.T.REASON_DDS_LOCATION_FALLBACK_TO_PHOTO,
    dds_equipment_type_not_found: i18n_1.T.REASON_DDS_EQUIPMENT_TYPE_NOT_FOUND,
    spida_calc_title_invalid: i18n_1.T.REASON_SPIDA_CALC_TITLE_INVALID,
    // spida calc span linking
    spida_calc_span_linking_target_pole_not_found: i18n_1.T.REASON_SPIDA_CALC_SPAN_LINKING_TARGET_POLE_NOT_FOUND,
    spida_calc_span_linking_span_mismatch: i18n_1.T.REASON_SPIDA_CALC_SPAN_LINKING_SPAN_MISMATCH,
    spida_calc_span_linking_wires_count_mismatch: i18n_1.T.REASON_SPIDA_CALC_SPAN_LINKING_WIRES_COUNT_MISMATCH,
    spida_calc_span_linking_wires_too_many: i18n_1.T.REASON_SPIDA_CALC_SPAN_LINKING_WIRES_TOO_MANY,
    spida_calc_span_linking_span_guys_count_mismatch: i18n_1.T.REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUYS_COUNT_MISMATCH,
    spida_calc_span_linking_wire_owner_mismatch: i18n_1.T.REASON_SPIDA_CALC_SPAN_LINKING_WIRE_OWNER_MISMATCH,
    spida_calc_span_linking_wire_usage_group_mismatch: i18n_1.T.REASON_SPIDA_CALC_SPAN_LINKING_WIRE_USAGE_GROUP_MISMATCH,
    spida_calc_span_linking_wire_size_mismatch: i18n_1.T.REASON_SPIDA_CALC_SPAN_LINKING_WIRE_SIZE_MISMATCH,
    spida_calc_span_linking_wire_tension_group_mismatch: i18n_1.T.REASON_SPIDA_CALC_SPAN_LINKING_WIRE_TENSION_GROUP_MISMATCH,
    spida_calc_span_linking_span_guy_owner_mismatch: i18n_1.T.REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_OWNER_MISMATCH,
    spida_calc_span_linking_span_guy_usage_group_mismatch: i18n_1.T.REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_USAGE_GROUP_MISMATCH,
    spida_calc_span_linking_span_guy_size_mismatch: i18n_1.T.REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_SIZE_MISMATCH,
    spida_calc_span_linking_span_guy_tension_group_mismatch: i18n_1.T.REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_TENSION_GROUP_MISMATCH,
    spida_calc_span_linking_span_guy_attachment_height_exceed_agl: i18n_1.T.REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_ATTACHMENT_HEIGHT_EXCEED_AGL,
    spida_calc_span_linking_span_guy_mid_span_height_exceed_agl: i18n_1.T.REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_MID_SPAN_HEIGHT_EXCEED_AGL,
    spida_calc_span_linking_span_guy_height_exceed_agl: i18n_1.T.REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_HEIGHT_EXCEED_AGL
};
/**
 * Number field Ids which are expressed in imperial units only.
 *
 *  - GLC (")
 *  - Circumference (")
 */
var IMPERIAL_NUMBER_FIELDS = ['circumference'];
var ExportNotificationDetailCtrl = /** @class */ (function () {
    function ExportNotificationDetailCtrl(notificationEntry, collection) {
        var _a;
        this.notificationEntry = notificationEntry;
        this.customizedFieldTitle = (_a = notificationEntry.reason) === null || _a === void 0 ? void 0 : _a.customizedFieldTitle;
        this.collection = collection;
        this.field = this.getCollectionField();
    }
    ExportNotificationDetailCtrl.prototype.getFormName = function () {
        return this.collection.formTitle;
    };
    ExportNotificationDetailCtrl.prototype.getFieldName = function () {
        if (!!this.customizedFieldTitle) {
            return this.customizedFieldTitle;
        }
        return this.field == null ? (0, i18n_1.Translate)(i18n_1.T.UNKNOWN) : this.field.schema.displayName;
    };
    ExportNotificationDetailCtrl.prototype.getFieldPath = function () {
        if (this.field == null) {
            return [(0, i18n_1.Translate)(i18n_1.T.UNKNOWN)];
        }
        var path = [];
        var parent = this.field.parent;
        while (parent != null && parent.parent != null) {
            var fieldTitle = parent.title;
            var schemaTitle = parent.formTitle;
            if (fieldTitle !== schemaTitle) {
                path.push("".concat(fieldTitle, " (").concat(schemaTitle, ")"));
            }
            else {
                path.push(schemaTitle);
            }
            parent = parent.parent.parent;
        }
        return path.reverse();
    };
    ExportNotificationDetailCtrl.prototype.getMessageCode = function () {
        return this.notificationEntry.code;
    };
    ExportNotificationDetailCtrl.prototype.getReason = function () {
        if (this.notificationEntry.reason == null) {
            return null;
        }
        var reason = this.notificationEntry.reason.reason;
        var translationKey = exports.MessageReasonTranslations[reason];
        if (translationKey == null) {
            return null;
        }
        return (0, i18n_1.Translate)(translationKey, this.notificationEntry.reason);
    };
    ExportNotificationDetailCtrl.prototype.hasDefaultValue = function () {
        return this.notificationEntry.defaultValue != null;
    };
    ExportNotificationDetailCtrl.prototype.getDefaultValue = function () {
        var defaultValue = this.notificationEntry.defaultValue || (0, i18n_1.Translate)(i18n_1.T.UNKNOWN);
        if (this.field == null) {
            return defaultValue;
        }
        if (core_shared_1.CollectionModelFieldHeight.isHeightField(this.field)) {
            var targetUnit = services_1.Services.UserSettings.units;
            return core_shared_2.IkeUnit.display(parseFloat(defaultValue), targetUnit, core_shared_2.IkeUnit.METER);
        }
        if (IMPERIAL_NUMBER_FIELDS.indexOf(this.field.schema.id) !== -1) {
            return core_shared_2.IkeUnit.display(parseFloat(defaultValue), core_shared_2.IkeUnit.INCH, core_shared_2.IkeUnit.METER);
        }
        if (this.isSimpleType(defaultValue)) {
            return defaultValue;
        }
        return this.formatObjectType(defaultValue);
    };
    ExportNotificationDetailCtrl.prototype.isSimpleType = function (value) {
        return typeof (value) === 'string' || typeof (value) === 'number';
    };
    ExportNotificationDetailCtrl.prototype.formatObjectType = function (obj) {
        var _this = this;
        return Object.keys(obj)
            .map(function (key) { return "".concat(_this.toProperCase(key), ": ").concat(obj[key]); })
            .join(', ');
    };
    ExportNotificationDetailCtrl.prototype.toProperCase = function (str) {
        return str[0].toUpperCase() + str.substring(1);
    };
    ExportNotificationDetailCtrl.prototype.getCollectionField = function () {
        var _this = this;
        if (this.notificationEntry.field.formId == null) {
            if (this.collection.hasField(this.notificationEntry.field.fieldId)) {
                return this.collection.getField(this.notificationEntry.field.fieldId);
            }
            else {
                return null;
            }
        }
        var targetField;
        this.collection.forEachField(function (field) {
            if (core_shared_1.CollectionModelFieldSubForm.isSubFormField(field)) {
                var instance = field.getInstance(_this.notificationEntry.field.formId);
                if (instance != null && instance.hasField(_this.notificationEntry.field.fieldId)) {
                    targetField = instance.getField(_this.notificationEntry.field.fieldId);
                    return false;
                }
                else if (field.schema.id === _this.notificationEntry.field.fieldId) {
                    targetField = field;
                    return false;
                }
            }
            return true;
        });
        return targetField;
    };
    return ExportNotificationDetailCtrl;
}());
exports.ExportNotificationDetailCtrl = ExportNotificationDetailCtrl;
//# sourceMappingURL=export.notification.detail.ctrl.js.map